import React from "react";
import {
  Box,
  Heading,
  Badge,
  useColorModeValue,
  VStack,
  HStack,
  Skeleton,
  Flex,
} from "@chakra-ui/react";
import { Trans } from "@lingui/react/macro";
import { DataDump } from "./DataDump";
import { IDevice } from "../../types/deviceInterface";

const deviceTypeLookup = new Map<number, string>([
  [-1, "DRAGINO"],
  [0, "SENSOR"],
  [1, "SENSOR"],
  [2, "AUTOPLANT"],
  [3, "ENVIRONMENT"],
  [4, "RELAY"],
  [5, "VALVE"],
  [6, "VALVE"],
  [7, "PUMP"],
]);

const DeviceTile = ({ device }: { device: IDevice | undefined }) => {
  const boxColor = useColorModeValue("white", "gray.900");
  const textColor = useColorModeValue("gray.800", "gray.200");

  if (!device) {
    return (
      <Box height={300}>
        <VStack align="start" spacing={4}>
          <HStack spacing={4}>
            <Skeleton height="20px" />
            <Skeleton height="20px" />
            <Skeleton height="20px" />
            <Skeleton height="20px" />
            <Skeleton height="20px" />
            <Skeleton height="20px" />
          </HStack>
        </VStack>
      </Box>
    );
  }

  const deviceType = deviceTypeLookup.get(device?.device_type ?? 0) || "UNKNOWN";

  return (
    <VStack align="start" spacing={4}>
      <Flex w="100%" justify="space-between" align="center">
        <Heading size="md">{device.device_name ?? <Trans>Unnamed device</Trans>}</Heading>
        <Badge colorScheme="green">{deviceType}</Badge>
      </Flex>
      <Heading size="sm" mb={2}>
        <Trans>Current Data:</Trans>
      </Heading>
      <DataDump device={device} />
    </VStack>
  );
};

export default DeviceTile;
